export type StatusType = typeof STATUS_TYPE[keyof typeof STATUS_TYPE];

export const STATUS_TYPE = {
  PRESENT: 'PRESENT',
  ABSENT: 'ABSENT',
  IDK: 'IDK',
  UNDECIDED: 'UNDECIDED',
  EMPTY: 'EMPTY',
} as const;
